/**
 * Admin API
 * 관리자 전용 API
 */

import { apiClient } from '../../../core/api/client';

const SUPPLIER_BASE_PATH = '/api/v1/supplier';
const RIDER_BASE_PATH = '/api/v1/rider';
const ADMIN_BASE_PATH = '/api/v1/mob/admin';

export interface SupplierListItem {
    suppId: string;
    suppName: string;
    suppType: string;
    statusCode: string;
    gradeName: string;
}

export interface RiderListItem {
    riderId: string;
    riderName: string;
    suppId: string;
    phoneNum?: string;
    contStatus?: string;
    deliveryMeth?: string;
}

export interface SwitchResponse {
    accessToken: string;
    refreshToken: string;
    prmCode: string;
    suppId?: string;
    riderId?: string;
}

/**
 * 전체 협력사 목록 조회
 */
export const getSupplierList = async (): Promise<SupplierListItem[]> => {
    const response = await apiClient.get<{ totalCount: number; suppliers: SupplierListItem[] }>(
        `${SUPPLIER_BASE_PATH}/list`
    );
    return response.data.suppliers;
};

/**
 * 전체 라이더 목록 조회
 */
export const getRiderList = async (): Promise<RiderListItem[]> => {
    const response = await apiClient.get<{ totalCount: number; riders: RiderListItem[] }>(
        `${RIDER_BASE_PATH}/list`
    );
    return response.data.riders;
};

/**
 * 특정 협력사의 라이더 목록 조회
 */
export const getRidersBySupplier = async (suppId: string): Promise<RiderListItem[]> => {
    const response = await apiClient.get<{ totalCount: number; riders: RiderListItem[] }>(
        `${RIDER_BASE_PATH}/list`,
        { params: { suppId } }
    );
    return response.data.riders;
};

/**
 * 관리자 → 협력사 전환 (새 토큰 발급)
 */
export const switchToSupplier = async (suppId: string): Promise<SwitchResponse> => {
    const response = await apiClient.post<SwitchResponse>(
        `${ADMIN_BASE_PATH}/switch-to-supplier`,
        null,
        { params: { suppId } }
    );
    return response.data;
};

/**
 * 관리자 → 라이더 전환 (새 토큰 발급)
 */
export const switchToRider = async (riderId: string): Promise<SwitchResponse> => {
    const response = await apiClient.post<SwitchResponse>(
        `${ADMIN_BASE_PATH}/switch-to-rider`,
        null,
        { params: { riderId } }
    );
    return response.data;
};
